import { charts } from '@ecosystem/newron-design-system';
import { LineChartGroup } from '@ecosystem/newron-design-system/build/exports/datavis';
import React, { useEffect } from 'react';

import { getStatistics } from '../../../shared/services/collections.service';
import { InsightRendererProps } from '../../../shared/types';

import { getCollectionsChartDataByProposition, getCollectionsChartDataByUserType } from './dataTransformation';

const { ChartScaleType, LineChart } = charts;

export interface StatsRendererData {
  type: string;
  userTypes?: string[];
}

enum ChartType {
  CollectionsByUserType = 'collections_by_user_type',
  CollectionsByProposition = 'collections_by_proposition',
}

export const StatsRenderer: React.FC<InsightRendererProps<StatsRendererData>> = ({
  insight,
  onLoaded,
}: InsightRendererProps<StatsRendererData>) => {
  const { data: insightData } = insight;
  const { userTypes } = insightData;

  const [chartData, setChartData] = React.useState<LineChartGroup[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const loadedData = await getStatistics();

      if (insightData.type === ChartType.CollectionsByUserType) {
        setChartData(getCollectionsChartDataByUserType(loadedData, { userTypes }));
      } else if (insightData.type === ChartType.CollectionsByProposition) {
        setChartData(getCollectionsChartDataByProposition(loadedData, { userTypes }));
      }

      onLoaded();
    };
    fetchData();
  }, [insightData.type, onLoaded, userTypes]);

  if (!chartData || chartData.length === 0) {
    return null;
  }

  return (
    <div id="stats-renderer">
      <LineChart
        width={2000}
        data={chartData}
        xScaleType={ChartScaleType.Time}
        yScaleType={ChartScaleType.Linear}
        xKey={'date'}
        yKey={'total'}
        showMarkers={false}
        tooltipProps={{ header: 'Total number' }}
      />
    </div>
  );
};
